import axiosInstance from "auth/FetchInterceptor";
import {
  SEARCH_TRIP,
  GET_TRIP_DETAIL,
  TRIP_COUNT_BY_STATUS,
} from "constants/ApiConstant";

const OrderTripService = {};

OrderTripService.searchTrip = function (data) {
  return axiosInstance.post(SEARCH_TRIP, data);
};

OrderTripService.getTripDetail = function (tripId) {
  return axiosInstance.get(`${GET_TRIP_DETAIL}/${tripId}`);
};

OrderTripService.getTripCountByStatus = function (data) {
  return axiosInstance.post(TRIP_COUNT_BY_STATUS, data);
};

export default OrderTripService;